import { useMemo } from 'react';
import { useLocale } from '../../../context/LocaleContext';
import { useCalendarStyles } from '../Calendar.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const DayLabelGrid = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  "aria-hidden": true,
  style: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    marginBottom: '4px'
  },
  children: children
});
const DayLabelCell = ({
  children,
  style
}) => /*#__PURE__*/_jsx("div", {
  style: style,
  children: children
});
const CalendarDayHeaders = ({
  firstDayOfWeek
}) => {
  const locale = useLocale();
  const {
    dayHeaderStyle
  } = useCalendarStyles();
  const dayAbbreviations = useMemo(() => {
    const formatter = new Intl.DateTimeFormat(locale, {
      weekday: 'short'
    });
    return Array.from({
      length: 7
    }, (_, i) => formatter.format(new Date(2026, 0, 4 + i)));
  }, [locale]);
  const orderedAbbreviations = [...dayAbbreviations.slice(firstDayOfWeek), ...dayAbbreviations.slice(0, firstDayOfWeek)];
  return /*#__PURE__*/_jsx(DayLabelGrid, {
    children: orderedAbbreviations.map(abbr => /*#__PURE__*/_jsx(DayLabelCell, {
      style: dayHeaderStyle,
      children: abbr
    }, abbr))
  });
};
export default CalendarDayHeaders;